export enum SCREEN_QUERY {
    SMALL = '(max-width: 767px)',
    MEDIUM = '(min-width: 768px) and (max-width: 1299px)',
    LARGE = '(min-width: 1300px)',
}
